import React from 'react'
import NumberFormat from 'react-number-format'
import { Column } from '@resurs/midas-react'
import shortid from 'shortid'
import { Countries } from '@merchant-portal/mp-models'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { getText } from '../../../../internal/TextLabels'
import { InfoLineKeys, InfoLineProperties, InfoLineType } from './utils'
import styles from './PaymentPerMonthCard.module.scss'

export const PaymentPerMonthCard = ({ option, amount }) => {
  const { country } = useLocaleState()
  const renderInfoLineValue = (key, value) => {
    const type = InfoLineProperties[key].type
    if (type === InfoLineType.MONTH) {
      return `${value} ${
        value === 1
          ? getText('payApply.paymentPerMonth.month')
          : getText('payApply.paymentPerMonth.months')
      }`
    }
    return (
      <NumberFormat
        value={Number(value)}
        displayType="text"
        decimalScale={InfoLineProperties[key].decimals === 0 ? 0 : 2}
        fixedDecimalScale
        thousandSeparator=" "
        decimalSeparator=","
        renderText={formattedValue =>
          type === InfoLineType.CURRENCY
            ? getText('default.currency', formattedValue)
            : `${formattedValue} %`
        }
      />
    )
  }

  const renderInfoLine = (key, value) => {
    return (
      <div className={styles.infoLine} key={shortid.generate()}>
        {`${InfoLineProperties[key].label}: `}
        <span>
          {renderInfoLineValue(key, value)}{' '}
          {InfoLineProperties[key].reservations &&
            Array(InfoLineProperties[key].reservations)
              .fill('*')
              .map(reservation => (
                <span key={shortid.generate()}>{reservation}</span>
              ))}
        </span>
      </div>
    )
  }
  return (
    <Column col4 colMd12>
      <div className={styles.paymentPerMonthCard}>
        <h6>{option.value.name}</h6>

        {renderInfoLine(
          InfoLineKeys.DURATION_IN_MONTHS,
          option.value.durationInMonths,
        )}
        {renderInfoLine(
          InfoLineKeys.NORMAL_MONTHLY_REPAYMENT_AMOUNT,
          option.value.normalMonthlyRepaymentAmount,
        )}
        {renderInfoLine(InfoLineKeys.CREDIT_AMOUNT, amount)}
        {renderInfoLine(InfoLineKeys.INTEREST, option.value.interest)}
        {country !== Countries.FI &&
          renderInfoLine(
            InfoLineKeys.ARRANGEMENT_FEE,
            option.value.arrangementFee,
          )}
        {renderInfoLine(
          InfoLineKeys.MONTHLY_ADMIN_FEE,
          option.value.monthlyAdminFee,
        )}
        {renderInfoLine(
          InfoLineKeys.EFFECTIVE_INTEREST,
          option.value.effectiveInterest,
        )}
        {renderInfoLine(InfoLineKeys.CREDIT_COST, option.value.creditCost)}
        {renderInfoLine(
          InfoLineKeys.TOTAL_LOAN_COST,
          option.value.totalLoanCost,
        )}
      </div>
    </Column>
  )
}
